'use client';
import { ToastContainer } from 'react-toastify';

const ClientToastContainer = () => {
    return <ToastContainer />;
};

export default ClientToastContainer;